module.exports = __webpack_public_path__ + "static/media/ravenclaw.59559226.png";